/**
 * usePermissions Hook
 * Provides role-based permission checks for UI components
 */

import { useAuth } from './useAuth';

export interface Permissions {
  isAdmin: boolean;
  isCustomer: boolean;
  canEditAdminFields: boolean;
  canAddServiceRecords: boolean;
  canDeleteTrucks: boolean;
  canRegisterCustomers: boolean;
  canViewAdminDashboard: boolean;
  canEditOwnProfile: boolean;
}

/**
 * Hook to check user permissions based on role
 */
export function usePermissions(): Permissions {
  const { user } = useAuth();

  const isAdmin = user?.role === 'admin';
  const isCustomer = user?.role === 'customer';

  return {
    isAdmin,
    isCustomer,
    canEditAdminFields: isAdmin,
    canAddServiceRecords: isAdmin, // ADMIN ONLY - service records management
    canDeleteTrucks: isAdmin || isCustomer, // Allow customers to delete their own trucks
    canRegisterCustomers: isAdmin,
    canViewAdminDashboard: isAdmin,
    canEditOwnProfile: true, // Both roles can edit their own profile
  };
}

export default usePermissions;
